import React, { Fragment } from 'react';
import DOMPurify from 'dompurify';

import get from 'lodash/get';
import map from 'lodash/map';
import compact from 'lodash/compact';
import slugify from 'slugify';

import {
  getAsPath
} from 'zoomforth_tools/standard_feed_filtering.js';

export const makeJobFeedItemFieldClassName = (name)=>
  `field-${classifyString(name)}`;
  
export const makeJobFeedItemClassNames = (job, itemCssClassFields) =>
  map(itemCssClassFields, (fieldName) => classifyString(`job-feed-item-${fieldName}-${job[fieldName]}`));
  
const classifyString = (strn) => slugify(strn, {
  lower: true,
  strict: true   // strip special characters except replacement chars (https://github.com/simov/slugify/blob/master/config/charmap.json)
});

const renderStandard = ({ render, datum, fieldName, className, label, index })=>
  render({ 
    fieldName, 
    className,
    label, 
    content:getAsPath(datum, fieldName), // using `get` allows fieldNames to be specified with a path like `a.b.c`
    index
  });


const renderStandardHtml = ({ render, datum, fieldName, className, label, index })=>
  render({ 
    fieldName, 
    className,
    label, 
    content:<span 
        dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(getAsPath(datum,fieldName)) }}
      />,
    index
  });


const renderLink = ({ render, datum, urlFieldName, url, textFieldName, text, className, label, index })=> 
  render({ 
    className,
    label, 
    content: <a href={getAsPath(datum, urlFieldName, url)}>{get(datum, textFieldName, text)}</a>,
    index
  });


const renderMulti = ({ render, datum, className, fieldNames, label, index })=> 
  render({ 
    className,
    label, 
    content: <Fragment>{
      compact(map(fieldNames, (fieldName)=> getAsPath(datum, fieldName))).join(', ')
    }</Fragment>,
    index
  });


const RENDER_STANDARD = 'RENDER_STANDARD';
const RENDER_LINK = 'RENDER_LINK';
const RENDER_MULTI = 'RENDER_MULTI';
const RENDER_HTML = 'RENDER_HTML';


const JOB_FEED_FIELD_RENDER_TYPE_MAPPING = {
  [RENDER_STANDARD]: renderStandard,
  [RENDER_LINK]: renderLink,
  [RENDER_MULTI]: renderMulti,
  [RENDER_HTML]: renderStandardHtml
};

export const getJobFeedFieldRenderForType = (type)=>
  JOB_FEED_FIELD_RENDER_TYPE_MAPPING[type];

